export enum restaurantCalendarActionsTypes {
  GET_RESTAURANT_CALENDAR_REQUEST = 'GET_RESTAURANT_CALENDAR_REQUEST',
  GET_RESTAURANT_CALENDAR_SUCCESS = 'GET_RESTAURANT_CALENDAR_SUCCESS',
  GET_RESTAURANT_CALENDAR_FAILURE = 'GET_RESTAURANT_CALENDAR_FAILURE',
}
